import { useCallback, useEffect, useState } from 'react';
import { getSupabaseAdmin } from '../../components/supabaseClient';

// Counts `document_backups` rows for the given documentPath so the patient
// header's version badge can show "V<n> · EDITED" instead of a hardcoded "V1".
// Uses the admin client (same as VersionHistoryModal) since RLS restricts the
// backups table to admin reads.
//
// Returns { count, refresh, loading } — call refresh() after a new version is
// created (or after restore) to re-fetch.
export function useVersionCount(documentPath, schema = null) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!documentPath) {
      setCount(0);
      return;
    }
    setLoading(true);
    try {
      const sb = getSupabaseAdmin();
      // Cross-schema: read the count from the doc's OWN schema (the patient's,
      // for a foreign chart), not the viewer's home. null → home (unchanged).
      const client = schema ? sb.schema(schema) : sb;
      const { count: c, error } = await client
        .from('document_backups')
        .select('id', { count: 'exact', head: true })
        .eq('original_path', documentPath);
      if (error) {
        console.warn('[useVersionCount] count failed:', error.message);
        setCount(0);
      } else {
        setCount(c || 0);
      }
    } catch (err) {
      console.warn('[useVersionCount] error:', err.message);
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, [documentPath, schema]);

  useEffect(() => { refresh(); }, [refresh]);

  return { count, loading, refresh };
}
